import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  loginUrl = environment.baseBackendUrl + '/login' 
  
  constructor(private http: HttpClient) { }

  processLogin(dataLogin){
    return this.http.post(this.loginUrl, dataLogin);
  }

}
